import React, { useEffect, useRef, useState } from 'react'
import Skeleton from '@material-ui/lab/Skeleton'

//helpers
import Api from '../../../__helpers/api'

//components
import Chart from './Chart'

//dispatcher
import { useSelector, useDispatch } from 'react-redux'

//modals
import WrongAnswersModal from '../../modals/questions/WrongAnswers'

//actions
import { sortStudentsByWrongAnswers } from '../../../__actions/instructor'

//images
import answers_5 from '../../../assets/images/dashboard/answers_5.jpg'
import answers_4 from '../../../assets/images/dashboard/answers_4.jpg'
import answers_3 from '../../../assets/images/dashboard/answers_3.jpg'
import answers_2 from '../../../assets/images/dashboard/answers_2.jpg'

const answers = {
    2: answers_2,
    3: answers_3,
    4: answers_4,
    5: answers_5
}

function WrongAnswers() {
    const dispatch = useDispatch()

    const [state, setState] = useState({
        loading: true,
        data: [],
        loadingWrongAnsers: true,
        isPrivate: true,
        quantity: 0,
        quality: 0
    })

    //refs
    const wrongAnsersModalRef = useRef(null)

    const __state = useSelector(state => state)
    //
    const currentGroup = __state.instructorReducer.group?.current || ''
    const currentTopic = __state.instructorReducer.topic?.current || ''
    const selectedUser = __state.instructorReducer.student?.id || ''

    useEffect(() => {
        loading(true)

        if (currentGroup) {
            const url = `center/stats/mowaq?topic_id=${currentTopic}&group_id=${currentGroup}&limit=${''}&user_id=${selectedUser}`

            Api.get(url)
                .then(res => {
                    setState(prev => ({
                        ...prev,
                        data: res.data
                    }))
                })
                .finally(() => {
                    loading(false)
                })
        } else {
            loading(true)
        }
        //
        if (currentGroup) {
            const url = `center/stats/qaq?group_id=${currentGroup}&topic_id=${currentTopic}&user_id=${selectedUser}`

            Api.get(url)
                .then(res => {
                    setState(prev => ({
                        ...prev,
                        quantity: res.data.percent_quantity,
                        quality: res.data.percent_quality
                    }))
                })
        }
    }, [currentGroup, currentTopic, selectedUser])

    const loading = loading => {
        setState(prev => ({
            ...prev,
            loading
        }))
    }

    const handleWrongAnserws = (answer, isPrivate, e) => {
        if (e.target) {
            if (e.target.classList.contains('wrong-by') || e.target.classList.contains('popover')) {
                return
            }
        }

        setPrivate(isPrivate)
        wrongAnsersModalRef.current.open(answer)
    }

    const handleSortStudentsByWrongAnswers = students => {
        let ids = []

        students.map(student => {
            ids.push(student.st_id)
        })
        
        dispatch(sortStudentsByWrongAnswers(ids))
    }

    const setPrivate = isPrivate => {
        setState(prev => ({
            ...prev,
            isPrivate
        }))
    }
    return (
        <div className="wrong-answers">
            <WrongAnswersModal
                data={state.data}
                private={state.isPrivate}
                loading={false}
                ref={wrongAnsersModalRef}
            />
            <h3>
                Често грешени въпроси от {currentTopic ? `Тема ${currentTopic}` : `всички теми`}
            </h3>
            <p>
                Затруднения на курсистите в темата
            </p>
            <div className="holder">

                <ul>
                    {state.loading ?
                        <>
                            <li>
                                <Skeleton className="answer-skeleton" style={{ width: '100%', height: '250px', transform: 'scale(1)' }} />
                            </li>
                            <li>
                                <Skeleton className="answer-skeleton" style={{ width: '100%', height: '250px', transform: 'scale(1)' }} />
                            </li>
                            <li>
                                <Skeleton className="answer-skeleton" style={{ width: '100%', height: '250px', transform: 'scale(1)' }} />
                            </li>
                        </>
                        :
                        state.data[0] ?
                            state.data.map((each, i) =>
                                i <= 2 ? <li
                                    key={each.id}
                                    onClick={e => handleWrongAnserws([each], false, e)}
                                >
                                    <picture style={{ backgroundImage: `url(${each.picture || (answers[each.answers.length])})` }}>

                                    </picture>
                                    <h4>
                                        {each.quest}
                                    </h4>
                                    <span className="wrong-by" onClick={() => handleSortStudentsByWrongAnswers(each.wrong_by_students)}>
                                        Сгрешени от {each.wrong_by} {each.wrong_by == 1 ? 'човек' : 'човека'}
                                        <ul className="popover">
                                            {each.wrong_by_students.map(student =>
                                                <li key={student.id} data-id={student.id}>
                                                    {student.name} {student.lastname}
                                                </li>
                                            )}
                                        </ul>
                                    </span>
                                </li> : '')
                            :
                            <li className="no-data">
                                Няма сгрешени въпроси
                            </li>
                    }
                </ul>
                {state.data[0] ?
                    <span
                        onClick={() => handleWrongAnserws(state.data, false)}
                        className="view-all"
                    >
                        Виж всички
                    </span>
                    :
                    ''
                }
            </div>
            <div className="statistics">
                <div className="holder quantity">
                    <div className="left">
                        <h4>
                            Количество на решените въпроси
                        </h4>
                        <ul>
                            <li>
                                <span className="green">

                                </span>
                                Решени въпроси
                            </li>
                        </ul>
                    </div>
                    <Chart
                        success={state.quantity}
                    />
                </div>
                <div className="holder quality">
                    <div className="left">
                        <h4>
                            Качество на решените въпроси
                        </h4>
                        <ul>
                            <li>
                                <span className="green">

                                </span>
                                Верни
                            </li>
                            <li>
                                <span className="red">

                                </span>
                                Грешни
                            </li>
                        </ul>
                    </div>
                    <Chart
                        success={state.quality}
                    />
                </div>
            </div>
        </div>
    )
}

export default WrongAnswers